import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

import { API } from 'aws-amplify';

import { 
    Button,
    Checkbox, 
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    MenuItem,
    Step,
    Stepper,
    StepLabel,
    TextField,
    Typography,
    useMediaQuery, } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import Address from '../Components/Address/Address';

const initialClaimState = {
  collection: false,
  collectionLine1: "",
  collectionLine2: "",
  collectionCity: "",
  collectionCountry: "",
  collectionPostcode: "",
  description: "",
  mobile: "",
  reason: "",
  returnLine1: "",
  returnLine2: "",
  returnCity: "",
  returnCountry: "",
  returnPostcode: "",
};

export default function WarrantyClaim(props) {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const steps = t('WarrantyClaimSteps', { returnObjects: true });

    const [activeStep, setActiveStep] = useState(0);
    const [loading, setLoading] = React.useState(false);
    const [sameAsCollection, setSameAsCollection] = useState(false);

    const [isInvalidReason, setIsInvalidReason] = useState(null);
    const [isInvalidDescription, setIsInvalidDescription] = useState(null);

    const [isInvalidMobile, setIsInvalidMobile] = useState(null);

    // const [isInvalidCollectionLine1, setIsInvalidCollectionLine1] = useState(null);
    // const [isInvalidCollectionCity, setIsInvalidCollectionCity] = useState(null);
    // const [isInvalidCollectionPostcode, setIsInvalidCollectionPostcode] = useState(null);

    // const [isInvalidReturnLine1, setIsInvalidReturnLine1] = useState(null);
    // const [isInvalidReturnCity, setIsInvalidReturnCity] = useState(null);
    // const [isInvalidReturnPostcode, setIsInvalidReturnPostcode] = useState(null);


    initialClaimState.mobile = props.user.phone_number;

    initialClaimState.collectionLine1 = props.defaultAddress.Line1
    initialClaimState.collectionLine2 = props.defaultAddress.Line2
    initialClaimState.collectionCity = props.defaultAddress.City
    initialClaimState.collectionCountry = props.defaultAddress.Country
    initialClaimState.collectionPostcode = props.defaultAddress.Postcode

    const [
      { collection, collectionLine1, collectionLine2, collectionCity, collectionCountry, collectionPostcode, description, mobile, reason, returnLine1, returnLine2, returnCity, returnCountry, returnPostcode },
      setState
    ] = useState(initialClaimState);

    const resetClaimState = () => {
      setState({ ...initialClaimState });
      setIsInvalidReason(null);
      setIsInvalidDescription(null);
      setIsInvalidMobile(null);
      // setIsInvalidCollectionLine1(null);
      // setIsInvalidCollectionCity(null);
      // setIsInvalidCollectionPostcode(null);
      // setIsInvalidReturnLine1(null);
      // setIsInvalidReturnCity(null);
      // setIsInvalidReturnPostcode(null);
      setLoading(false);
    };

    const validateStep = stepI => {
      switch (stepI) {
        case 0:
          const validReason = reason.length > 2;
          const validDescription = description.length > 3;
          setIsInvalidReason(!validReason);
          setIsInvalidDescription(!validDescription);

          return (validReason && validDescription) 
        case 1:
          const validMobile = mobile.length > 7;
          setIsInvalidMobile(!validMobile);

          let validCollectionAddress = true
          if (collection) {
            const validCollectionLine1 = collectionLine1.length > 0;
            const validCollectionCity = collectionCity.length > 0;
            const validCollectionPostcode = collectionPostcode.length > 0;

            // setIsInvalidCollectionLine1(!validCollectionLine1);
            // setIsInvalidCollectionCity(!validCollectionCity);
            // setIsInvalidCollectionPostcode(!validCollectionPostcode);

            validCollectionAddress = (validCollectionLine1 && validCollectionCity && validCollectionPostcode)
          }

          const validReturnLine1 = returnLine1.length > 0;
          const validReturnCity = returnCity.length > 0;
          const validReturnPostcode = returnPostcode.length > 0;

          // setIsInvalidReturnLine1(!validReturnLine1);
          // setIsInvalidReturnCity(!validReturnCity);
          // setIsInvalidReturnPostcode(!validReturnPostcode);

          return (validMobile && validCollectionAddress && validReturnLine1 && validReturnCity && validReturnPostcode)      
        default:
          break;
      }
    }

    const onChange = e => {
      const { name, value } = e.target;
      setState(prevState => ({ ...prevState, [name]: value }));
    }

    const handleNext = () => {
      setLoading(false);
      if (validateStep(activeStep)) {
        setActiveStep(prevActiveStep => prevActiveStep + 1)
      }
    };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleReset = () => {
    props.setWarrantyClaim(false);
    setActiveStep(0);
    resetClaimState();
  };

  const handleSameAsCollection = (e) => {
    setSameAsCollection(e.target.checked)

    if (e.target.checked) {
      onChange({target: {name: 'returnLine1', value: collectionLine1}})
      onChange({target: {name: 'returnLine2', value: collectionLine2}})
      onChange({target: {name: 'returnCity', value: collectionCity}})
      onChange({target: {name: 'returnCountry', value: collectionCountry}})
      onChange({target: {name: 'returnPostcode', value: collectionPostcode}})
    } else {
      onChange({target: {name: 'returnLine1', value: ''}})
      onChange({target: {name: 'returnLine2', value: ''}})
      onChange({target: {name: 'returnCity', value: ''}})
      onChange({target: {name: 'returnCountry', value: ''}})
      onChange({target: {name: 'returnPostcode', value: ''}})
    }    
  };

  const handleSubmit = async () => {
    if (!validateStep(activeStep)) {
      return
    }
    setLoading(true);

    const payload = {
      "Collection": collection,
      "Description": description,
      "DeviceManufacturer": props.claimDetails.DeviceManufacturer,
      "DeviceModel": props.claimDetails.DeviceModel,
      "DeviceId": props.claimDetails.DeviceId,
      "Mobile": mobile,
      "Reason": reason,
      "ReturnAddress": {
          "Line1": returnLine1,
          "City": returnCity,
          "Country": returnCountry,
          "Postcode": returnPostcode
      }
    }

    if (returnLine2 !== undefined && returnLine2.length > 0) {
      payload.ReturnAddress.Line2 = returnLine2
    }

    if (collection) {
      payload.CollectionAddress = {
          "Line1": collectionLine1,
          "City": collectionCity,
          "Country": collectionCountry,
          "Postcode": collectionPostcode
      }

      if (collectionLine2 !== undefined && collectionLine2.length > 0) {
        payload.CollectionAddress.Line2 = collectionLine2
      }
    }

    const request = {
        body: payload,
    }

    try {
      await API.post('CrystalusionAPI', `/warranty/${props.claimDetails.WarrantyCode}`, request)

      handleNext()
      const userDetails = await API.get('CrystalusionAPI', '/user');
      props.setUserDetails(userDetails);
    } catch (error) {
      console.log("error: ", error)
      setLoading(false);
    }

  }

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <>
        <TextField
            variant="outlined"
            margin="normal"
            select
            required
            fullWidth
            id="reason"
            label={t('FormLabels.Reason')}
            name="reason"
            value={reason}
            onChange={onChange}
            error={isInvalidReason}
        >
            <MenuItem value="SMASHED">{t('FormLabels.Reasons.Smashed')}</MenuItem>
            <MenuItem value="NOT_WORKING">{t('FormLabels.Reasons.NotWorking')}</MenuItem>
            <MenuItem value="OTHER">{t('FormLabels.Reasons.Other')}</MenuItem>
        </TextField>
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            multiline
            rows={2}
            id="description"
            label={t('FormLabels.Description')}
            name="description"
            value={description}
            onChange={onChange}
            error={isInvalidDescription}
        />
        </>
      );
    case 1:
      return (
        <>
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="mobile"
            label={t('FormLabels.Mobile')}
            name="mobile"
            type="tel"
            value={mobile}
            onChange={onChange}
            error={isInvalidMobile}
        />
        <Typography variant="body2" align="center" color="inherit" style={{flexGrow: 1}}>
            {t('WarrantyClaim.CollectionHelp')}
        </Typography>
        <TextField
            variant="outlined"
            margin="normal"
            select
            required
            fullWidth
            id="collection"
            label={t('FormLabels.Collection')}
            name="collection"
            value={collection}
            onChange={onChange}
        >
            <MenuItem value={false}>{t('FormLabels.CollectionOptions.No')}</MenuItem>
            <MenuItem value={true}>{t('FormLabels.CollectionOptions.Yes')}</MenuItem>
        </TextField>
        {collection ? (
          <>
            <Typography variant="body2" align="center" color="inherit" style={{flexGrow: 1}}>
              {t('WarrantyClaim.CollectionTime')}
            </Typography>
            <Address 
              isCollection={true} 
              line1={collectionLine1} 
              line2={collectionLine2} 
              city={collectionCity} 
              country={collectionCountry} 
              postcode={collectionPostcode} 
              onChange={onChange}
            />
            <FormControlLabel
              value={t('FormLabels.SameAsCollection')}
              control={<Checkbox checked={sameAsCollection} color="primary" onChange={handleSameAsCollection}/>}
              label={t('FormLabels.SameAsCollection')}
              labelPlacement="end"
            />
          </>
        ) : (
          null
        )}
        { collection && sameAsCollection ? (
          null
        ) : (
          <Address 
            isCollection={false} 
            line1={returnLine1} 
            line2={returnLine2} 
            city={returnCity} 
            country={returnCountry} 
            postcode={returnPostcode} 
            onChange={onChange}
          />
        )}
        </>
      );
    case 2:
      return (
        <>
        <Typography variant="h3" align="center" color="inherit" gutterBottom={true} style={{flexGrow: 1}}>
          <img width="70" src="success.png" alt={t('WarrantyClaim.SuccessTitle')} />
        </Typography>
        <Typography variant="body1" align="center" color="inherit" style={{flexGrow: 1}}>
          {t('WarrantyClaim.SuccessBody')}
        </Typography>
        </>
      );
    default:
      return 'Unknown stepIndex';
    }
  }

  const getStepActions = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <>
        <Button onClick={handleReset} color="secondary">
          {t('Cancel')}
        </Button>
        <Button onClick={handleNext} color="primary">
          {t('Next')}
        </Button>
        </>
      );
    case 1:
      return (
        <>
        <Button onClick={handleBack}>
          {t('Back')}
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={loading}>
          {t('Submit')}
          &nbsp;
          {loading && <CircularProgress size={24}/>}
        </Button>
        </>
      );
    case 2:
      return (
        <>
        <Button onClick={handleReset} color="primary">
          {t('Close')}
        </Button>
        </>
      );
    default:
      return 'Unknown stepIndex';
    }
  }

  return (
        <Dialog
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={props.warrantyClaim}
        fullScreen={fullScreen}
        fullWidth={true}
        scroll="body"
        >
        <DialogTitle>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      </DialogTitle>
          <DialogContent>
            {getStepContent(activeStep)}
          </DialogContent>
        <DialogActions>
            {getStepActions(activeStep)}
        </DialogActions>
      </Dialog>
    )
}